/* eslint-disable react-hooks/exhaustive-deps */
import { MaybeElement } from "@blueprintjs/core"
import { BlueprintIcons_16Id } from "@blueprintjs/icons/src/generated/16px/blueprint-icons-16"
import { POST_STATUS } from "src/libs/interfaces/layouts"
import { LinksFeedContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { IPrimitiveProps } from "../section/Primitive"
import ExternalLinkFeed from "./links-feed/ExternalLinkFeed"
import LocalLinkFeed from "./links-feed/LocalLinkFeed"
import "./links-feed/style.scss" 

export interface ILinkPostType {
    _id: POST_STATUS,
    icon: BlueprintIcons_16Id | MaybeElement,
    title: string
}
export const LINK_POST_TYPES : ILinkPostType[] = [
    { _id: POST_STATUS.PUBLISH, icon: "time", title: `link_${POST_STATUS.PUBLISH}` }, 
    { _id: POST_STATUS.PENDING, icon: "eye-on", title: `link_${POST_STATUS.PENDING}` }, 
    { _id: POST_STATUS.DRAFT, icon: "box", title: `link_${POST_STATUS.DRAFT}` }
]
/* Protopia Ecosystem component */
export interface ILinksFeedPrimitiveProps extends IPrimitiveProps {
   
}
const LinksFeedPrimitive = (props: ILinksFeedPrimitiveProps): JSX.Element => {
    
    const isLocal: boolean              = useLandingStore( (state: ILandingStore) => state.isLocal )
    const {position}                    = usePosition( props.primitive || {position: {}} )
    const primitive: LinksFeedContent   = ( { ...props.primitive || {}, ...position.data } ) as LinksFeedContent 
    
    return <div className=' w-100' > 
        <div className='pe-links-feed-container w-100' data-primitive-type={primitive["data-primitive-type"]}>  
            <div className="container-fluid px-3">
                {
                    isLocal 
                        ?
                        <LocalLinkFeed primitive={primitive} section={props.section} />
                        :
                        <ExternalLinkFeed primitive={primitive} section={props.section} />
                }  
            </div>
        </div>       
    </div>
}
export default LinksFeedPrimitive

